module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "step-container"
  }, [_c('StepHeader', {
    attrs: {
      "currentStep": _vm.currentStep,
      "steps": _vm.steps
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-section"
  }, [_c('div', {
    staticClass: "export-section"
  }, [_c('button', {
    staticClass: "export-button",
    on: {
      "click": _vm.exportConfiguration
    }
  }, [_c('svg', {
    staticClass: "export-icon",
    attrs: {
      "fill": "none",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M11.5 15.577V6.927L9.17 9.257L8.462 8.539L12 5L15.539 8.539L14.831 9.258L12.5 6.927V15.577H11.5ZM5 19V14.962H6V18H18V14.962H19V19H5Z",
      "fill": "currentColor"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Export")])])]), _vm._v(" "), _c('div', {
    staticClass: "summary-table-section"
  }, [_c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-body"
  }, [_c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00075))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.waveName))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00016))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.surveyTitle))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00027))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.importerName))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00029))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.agencyName))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00076))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.formData.leadAgency))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.lang.W00077))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.scenariosNames))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-row"
  }, [_c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v("Audi " + _vm._s(_vm.lang.W00078))]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-cell"
  }, [_vm._v(_vm._s(_vm.carModelDistributionDisplay))])]), _vm._v(" "), _vm._l((_vm.competitorBrands), function(brand) {
    return _c('div', {
      staticClass: "wizard-table-row"
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(brand) + " " + _vm._s(_vm.lang.W00078))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(_vm.competitorCarModelDistributionDisplay[brand].join(", ")))])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "summary-table-section"
  }, [_c('div', {
    staticClass: "wizard-table-container"
  }, [_c('div', {
    staticClass: "wizard-table-header wizard-table-visits-header"
  }, [_c('div', [_vm._v(_vm._s(_vm.lang.SA0015))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.SA0044))]), _vm._v(" "), _c('div', [_vm._v("Checks")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.CM1034))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.lang.CM1035))])]), _vm._v(" "), _c('div', {
    staticClass: "wizard-table-body"
  }, _vm._l((_vm.formData.visits || []), function(visit) {
    return _c('div', {
      key: ((visit.LocationId) + "-" + (visit.ScenarioName)),
      staticClass: "wizard-table-row wizard-table-visits-row"
    }, [_c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(visit.LocationName))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(visit.ScenarioName))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(visit.NumberOfVisits))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(_vm.getAttachmentFileName(visit.ScenarioId, 'Briefing')))]), _vm._v(" "), _c('div', {
      staticClass: "wizard-table-cell"
    }, [_vm._v(_vm._s(_vm.getAttachmentFileName(visit.ScenarioId, 'Survey')))])])
  }), 0)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fefb4b42","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wizards/Audi/Step8.vue
// module id = 1737
// module chunks = 1